import { useTranslation } from 'react-i18next';
import UtilityDrawerBody from '../utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawer from '../utility-drawer/utility-drawer.component';
import { Box, Button, Typography } from '@mui/material';
import OrderItemCard from 'components/order-item-card/order-item-card.component';
import UtilityDrawerFooter from '../utility-drawer/utility-drawer-footer/utility-drawer-footer.component';

export const OrderItemDetailsDrawer = ({ open, close, drawerData }) => {
  const { t } = useTranslation();

  const { orderData } = drawerData ?? {};

  return (
    <UtilityDrawer
      open={open}
      onClose={close}
      data-testid="OrderItemDetailsDrawer.Drawer"
      title={t('drawer.OrderItemDetailsDrawer.title')}
    >
      <UtilityDrawerBody>
        {orderData?.orderItems?.map((item, index) => {
          return (
            <Box key={index} pt={2}>
              <Typography variant="h2" data-testid="OrderItem.Label">
                {t('drawer.OrderItemDetailsDrawer.Item.label')} {index + 1}
              </Typography>
              <OrderItemCard item={item} />
              {item?.options?.map(modifier => {
                return <OrderItemCard item={modifier} isModifier key={index} />;
              })}
            </Box>
          );
        })}
      </UtilityDrawerBody>
      <UtilityDrawerFooter>
        <Button
          fullWidth
          color="primary"
          onClick={close}
          data-testid="OrderItemDetailsDrawer.CloseButton"
        >
          {t('drawer.OrderItemDetailsDrawer.buttons.label')}
        </Button>
      </UtilityDrawerFooter>
    </UtilityDrawer>
  );
};

export default OrderItemDetailsDrawer;
